import React, { useLayoutEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";
import classNames from "classnames";
import { Tooltip } from "@td/ui";
import { translate } from "@td/shared_utils";
import { useTypes } from "../../../../contexts/types-context";

const TaskName = React.memo(({ task, restricted, onClick }) => {
  const { name, typeCd } = task;
  const types = useTypes();

  const containerRef = useRef();
  const [tooltipTitle, setTooltipTitle] = useState(null);

  const taskName = typeCd === types.OTHER
    ? name
    : translate(null, "care_team_tasks.types", typeCd.replace("TASKTYPE_", ""));

  useLayoutEffect(() => {
    const resolveTooltipTitle = () => {
      setTooltipTitle(
        containerRef.current.scrollWidth > containerRef.current.offsetWidth
          ? taskName
          : null
      );
    };

    resolveTooltipTitle();
    window.addEventListener("resize", resolveTooltipTitle);

    return () => {
      window.removeEventListener("resize", resolveTooltipTitle);
    };
  }, [containerRef.current, setTooltipTitle, taskName]);

  return (
    <Tooltip title={tooltipTitle}>
      <div
        ref={containerRef}
        onClick={onClick}
        className={classNames(styles.taskName, { [styles.restricted]: restricted })}
        data-testid="task-name"
      >
        {taskName}
      </div>
    </Tooltip>
  );
});

TaskName.propTypes = {
  task: PropTypes.shape({
    name: PropTypes.string,
    typeCd: PropTypes.string.isRequired,
  }),
  onClick: PropTypes.func.isRequired,
  restricted: PropTypes.bool.isRequired,
};

export default TaskName;
